import React from 'react';
import Button from 'devextreme-react/button';

import DataItemView from '../../../common/view/DataItemView';

import ContractAlertView from './ContractAlertView';

export default class ContractAlertListView extends DataItemView {
  static displayName = ContractAlertListView.name;

  constructor(props) {
    super(props);

    this.createContractAlertListener = this.onCreateContractAlert.bind(this);
    this.removeContractAlertListener = this.onRemoveContractAlert.bind(this);

    this.bindDataItem(props.contractAlertList);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.contractAlertList);
  }

  render() {
    if (!this.state.isDataBound)
      return (<div />);

    return (
      <div className="pwx-contract-section-list-view">
        <div className="pwx-contract-section-list-title">CONTRACT ALERTS</div>
        <div className="pwx-contract-section-list-content">
        {
          this.state.dataObjects.map(
            contractAlert => (<ContractAlertView key={contractAlert.key} contractAlert={contractAlert} onRemoveContractAlert={this.removeContractAlertListener} />)
          )
          }
          <div className="pwx-contract-section-list-command">
            <Button type="normal" text="Add Contract Alert" onClick={this.createContractAlertListener} />
          </div>
        </div>
      </div>
    );
  }

  onCreateContractAlert() {
    if (this.dataItem === null)
      return;

    this.dataItem.insertNewDataObject();
  }

  onRemoveContractAlert(contractAlert) {
    if (this.dataItem === null)
      return;

    if (contractAlert.isNew)
      this.dataItem.removeDataObject(contractAlert);
    else
      contractAlert.setIsDeleted(true);
  }
}